import React from "react";
import { Box, ListItemIcon, Checkbox, Typography } from "@mui/material";
import { List, ListItem, ListItemText } from "@mui/material";
import ListItemButton from "@mui/material/ListItemButton";
import { showVarianceIcon } from "utils/shared";
import StyledTornadoIcon from "components/TornadoIcon";

const CodeListSection = ({
  filteredProcCodeList,
  checkedItems,
  setCheckedItems,
}) => {
  const handleToggle = (item) => () => {
    const currentIndex = checkedItems.indexOf(item);
    const newCheckedItems = [...checkedItems];

    if (currentIndex === -1) {
      newCheckedItems.push(item);
    } else {
      newCheckedItems.splice(currentIndex, 1);
    }
    setCheckedItems(newCheckedItems);
  };

  return (
    <Box
      mt={2}
      sx={{ border: "1px solid black", height: "45vh", overflowY: "scroll" }}
    >
      <List dense>
        {filteredProcCodeList.map((item, index) => (
          <ListItem
            key={index}
            sx={{
              "& div.MuiListItemButton-dense": {
                padding: "0px 10px",
                height: "25px",
              },
            }}
            disablePadding
          >
            <ListItemButton role={undefined} onClick={handleToggle(item)} dense>
              <ListItemIcon sx={{ minWidth: "0px" }}>
                <Checkbox
                  edge="start"
                  checked={checkedItems.indexOf(item) !== -1}
                  tabIndex={-1}
                  disableRipple
                  inputProps={{ "aria-labelledby": item }}
                />
              </ListItemIcon>
              <ListItemText
                primary={
                  <Box display="flex" alignItems="center">
                    <Typography variant="body1">
                      {item.codeDescription
                        ? `${item.code} - ${item.codeDescription}`
                        : `${item.code}`}
                    </Typography>
                    {showVarianceIcon(item) && <StyledTornadoIcon />}
                  </Box>
                }
              />
            </ListItemButton>
          </ListItem>
        ))}
      </List>
    </Box>
  );
};

export default CodeListSection;
